// extracted by mini-css-extract-plugin
export default {"container":"BulkApply_container__D0z9+","label":"BulkApply_label__3eWHu","close":"BulkApply_close__A6ro3"};